import { render, staticRenderFns } from "./targetPage.vue?vue&type=template&id=2a644409&scoped=true&"
import script from "./targetPage.vue?vue&type=script&lang=js&"
export * from "./targetPage.vue?vue&type=script&lang=js&"
import style0 from "./targetPage.vue?vue&type=style&index=0&id=2a644409&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a644409",
  null
  
)

export default component.exports